/**
 * The shop checkout (`/shop/checkout`, studio-shop D5, D6): the `shop-checkout`
 * piece with the `shop-payment-step` piece as its payment once the order is
 * placed. Website-only (the escape hatch in shared-client-screens.md). A bag
 * with nothing left to buy points back to the bag.
 */
import { Link } from 'react-router-dom';

import { ShopCheckoutView, useShopCheckout } from '../../pieces/shop-checkout';
import { ShopPaymentStep } from '../../pieces/shop-payment-step';
import shared from '../../styles/shared.module.css';
import { usePageTitle } from '../../ui/usePageTitle';
import css from './ShopPages.module.css';

export function ShopCheckoutPage() {
  const checkout = useShopCheckout();
  usePageTitle('Checkout');
  const { status, order } = checkout.state;
  if (status === 'loading') return null;
  if (status === 'empty') {
    return (
      <div className={`${shared.wrap} ${css.flow} ${css.narrow} ${css.emptyCheckout}`}>
        <p>Nothing in your bag can be bought right now.</p>
        <Link className={`${shared.btn} ${shared.btnOutline}`} to="/shop/bag">
          Back to your bag
        </Link>
      </div>
    );
  }
  return (
    <div className={`${shared.wrap} ${css.flow}`}>
      <ShopCheckoutView
        {...checkout}
        payment={
          order && (
            <ShopPaymentStep
              key={order.id}
              orderId={order.id}
              claimToken={order.claimToken}
              total={order.total}
              currency={order.currency}
              onExpired={checkout.expire}
            />
          )
        }
      />
    </div>
  );
}
